import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

interface Frame {
  id: number,
  name: string
}

@Component({
  selector: 'vr-delete-modal',
  templateUrl: './create-audit-dialog.component.html',
  styleUrls: ['./create-audit-dialog.component.scss']
})
export class CreateAuditDialogComponent implements OnInit {
  frames: Frame[];
  filteredFrames: Frame[];
  selected: number;
  searchText: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
              private dialogRef: MatDialogRef<CreateAuditDialogComponent>,
              private http: HttpClient
  ) {}

  ngOnInit() {
    this.http.get(environment.API_PATH + 'frame', {withCredentials: true}).subscribe((response) => {
      if (response['success']) {
        this.frames = response['frames'].filter(f => f.is_published);
        this.frames.unshift({ id: 0, name: 'AUDIT PHOTO' });
        this.filteredFrames = this.frames;
      }
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  filterFrames() {
    const term = this.searchText.toLowerCase();
    this.filteredFrames = this.frames.filter(f => f.name.toLowerCase().includes(term));
  }

  selectFrame() {
    this.dialogRef.close(this.selected);
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/create-audit-dialog/create-audit-dialog.component.ts